// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"524":"d13788f5","668":"7b1d5cab"}[chunkId] + ".chunk.css";
};